import slugify from 'slugify';

// utils
import { IEntry } from '../locator.types';

export function generateDealerUrl(entry: Pick<IEntry, 'city' | 'name'>, locale = 'en') {
  return slugify(`${entry.name}-${entry.city}`, { locale });
}
